<script>
import ModalStudentInfoComponent from '../features/ModalStudentInfoComponent';
import ModalSelectCareerView from './ModalSelectCareerView';

export default {
  name: 'ModalStudentInfoView',
  components: {
    'modal-select-career-view': ModalSelectCareerView,
  },
  extends: ModalStudentInfoComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    class="subscription-account-modal"
    width="85%"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
    :show-close="false"
  >
    <!-- Cabecera personalizada del modal -->
    <template #header>
      <div class="student_modal_header">
        <div class="student_modal_header_icon">
          <i class="fas fa-user-graduate" />
        </div>
        <div class="student_modal_header_info">
          <h3 class="student_modal_title">
            Información de Inscripción
          </h3>
          <p class="student_modal_subtitle">
            Completa estos datos requeridos para personalizar tus cursos, simuladores y sesiones de asesoría
          </p>
        </div>
      </div>
    </template>

    <!-- Formulario principal estandarizado -->
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <!-- Sección 1: Carreras de Interés -->
      <div class="student_form_section">
        <div class="student_section_header">
          <h4 class="student_section_title">
            <i class="fas fa-graduation-cap" /> Carreras Universitarias de Interés
          </h4>
          <el-button
            type="primary"
            class="btn_section_action"
            @click="onSelectCareers"
          >
            <i class="fas fa-plus mr-1" /> Seleccionar Carreras
          </el-button>
        </div>

        <div class="student_table_wrap">
          <el-table
            v-if="formData.collection && formData.collection.length > 0"
            v-loading="isItemLoading"
            :data="formData.collection"
            style="width: 100%"
            max-height="250"
            class="student_careers_table"
            element-loading-spinner="el-icon-loading"
            :element-loading-text="itemLoadingMessage"
          >
            <el-table-column
              prop="name"
              label="Carrera"
              min-width="180"
            />
            <el-table-column
              label="Área"
              min-width="160"
            >
              <template #default="scope">
                <span class="badge_knowledge_area">
                  {{ scope.row.knowledgeArea ? scope.row.knowledgeArea.name : '-' }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              label="Universidad"
              min-width="160"
            >
              <template #default="scope">
                <span>{{ scope.row.university ? scope.row.university.name : '-' }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="Acción"
              width="90"
              align="center"
            >
              <template #default="scope">
                <el-button
                  type="danger"
                  link
                  size="small"
                  class="btn_delete_career"
                  title="Eliminar carrera"
                  @click="onDeleteCareer(scope.$index)"
                >
                  <i class="fas fa-trash-alt" />
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <div
            v-else
            class="student_empty_careers"
          >
            <i class="fas fa-info-circle mr-2" />
            <span>Aún no has agregado carreras. Haz clic en <strong>"Seleccionar Carreras"</strong> para elegir tus opciones universitarias.</span>
          </div>
        </div>
      </div>

      <!-- Sección 2: Preparatoria de Procedencia -->
      <div class="student_form_section">
        <div class="student_section_header">
          <h4 class="student_section_title">
            <i class="fas fa-school" /> Preparatoria de Procedencia
          </h4>
        </div>

        <el-form-item
          label="Preparatoria que cursa o cursó"
          prop="highSchool"
          class="mb-0"
        >
          <div class="highschool_input_group">
            <el-select
              v-model="formData.highSchool"
              clearable
              filterable
              placeholder="Selecciona tu preparatoria o bachillerato"
              value-key="id"
              class="highschool_select"
            >
              <el-option
                v-for="item in highSchools"
                :key="item.id"
                :label="item.name"
                :value="item"
              />
            </el-select>
            <el-button
              type="default"
              class="btn_add_highschool"
              @click="onActiveNewHighSchool"
            >
              <i class="fas fa-plus mr-1" /> Otra Preparatoria
            </el-button>
          </div>
        </el-form-item>

        <!-- Campo dinámico para nueva preparatoria -->
        <div
          v-if="isNewHighSchool"
          class="new_highschool_box mt-3"
        >
          <el-form-item
            label="Nombre de la nueva preparatoria"
            class="mb-0"
          >
            <div class="highschool_input_group">
              <el-input
                v-model="currentHighSchool"
                placeholder="Ej. Escuela Preparatoria Federal / Plantel"
                clearable
                class="highschool_input"
                @keyup.enter="onAddHighSchool(currentHighSchool)"
              />
              <el-button
                type="primary"
                class="btn_confirm_highschool"
                :disabled="!currentHighSchool"
                @click="onAddHighSchool(currentHighSchool)"
              >
                <i class="fas fa-check mr-1" /> Guardar
              </el-button>
            </div>
          </el-form-item>
        </div>
      </div>

      <!-- Sección 3: Expectativas Académicas -->
      <div class="student_form_section">
        <div class="student_section_header">
          <h4 class="student_section_title">
            <i class="fas fa-clipboard-list" /> Diagnóstico y Expectativas Académicas
          </h4>
        </div>

        <el-form-item
          label="¿Por qué quieres estudiar la(s) carrera(s) seleccionada(s)?"
          prop="selectedCareerObservation"
        >
          <el-input
            v-model="formData.selectedCareerObservation"
            type="textarea"
            :rows="2"
            placeholder="Describe tus intereses y metas profesionales principales..."
          />
        </el-form-item>

        <el-form-item
          label="¿Qué esperas de esta asesoría y acompañamiento?"
          prop="advisoryObservation"
        >
          <el-input
            v-model="formData.advisoryObservation"
            type="textarea"
            :rows="2"
            placeholder="Menciona qué objetivos deseas alcanzar durante tu preparación..."
          />
        </el-form-item>

        <el-form-item
          label="¿Qué materia se te dificulta más entre matemáticas y español? y ¿Por qué?"
          prop="subjectComplicationObservation"
          class="mb-0"
        >
          <el-input
            v-model="formData.subjectComplicationObservation"
            type="textarea"
            :rows="2"
            placeholder="Cuéntanos qué temas específicos requieren mayor reforzamiento..."
          />
        </el-form-item>
      </div>

      <!-- Sección 4: Información Adicional y Salud -->
      <div class="student_form_section">
        <div class="student_section_header">
          <h4 class="student_section_title">
            <i class="fas fa-user-shield" /> Información Adicional
          </h4>
        </div>

        <div class="condition_switch_row mb-3">
          <div class="condition_text">
            <span class="condition_label">¿Padece de alguna enfermedad o condición especial?</span>
            <span class="condition_hint">Nos permite brindarte asistencia adecuada durante tus clases y exámenes</span>
          </div>
          <el-switch
            v-model="formData.hasDiseaseOrSpecialCondition"
            active-color="#0D47A1"
            inactive-color="#cbd5e1"
            inline-prompt
            active-text="Sí"
            inactive-text="No"
            :inactive-value="false"
            :active-value="true"
          />
        </div>

        <el-form-item
          label="Dirección de residencia"
          prop="homeAddress"
        >
          <el-input
            v-model="formData.homeAddress"
            type="textarea"
            :rows="2"
            maxlength="255"
            show-word-limit
            placeholder="Calle, número, colonia, municipio o ciudad..."
          />
        </el-form-item>

        <el-form-item
          label="Acerca de ti"
          prop="about"
          class="mb-0"
        >
          <el-input
            v-model="formData.about"
            type="textarea"
            :rows="2"
            maxlength="255"
            show-word-limit
            placeholder="Información adicional sobre tu perfil, hobbies o intereses..."
          />
        </el-form-item>
      </div>
    </el-form>

    <!-- Footer del modal -->
    <template #footer>
      <div class="student_modal_footer">
        <span class="footer_note">
          <i class="fas fa-shield-alt mr-1" /> Tu información se gestiona de manera confidencial
        </span>
        <el-button
          type="primary"
          class="btn_submit_student_info"
          :loading="conf.isLoading"
          @click="onSubmitForm('formData')"
        >
          <i class="fas fa-paper-plane mr-2" /> Guardar y Finalizar
        </el-button>
      </div>
    </template>

    <!-- Modal hijo para selección de carreras -->
    <modal-select-career-view
      v-if="modalItemCareers.isVisible"
      :form-data="itemCareers"
      :conf="modalItemCareers"
    />
  </el-dialog>
</template>
